import React from "react"
import { useController } from "react-hook-form"
import { useTranslation } from "react-i18next"

import { MAX_LENGTH_DESCRIPTION_TEXT } from "shared/constants/app-constants"
import { InputRootProps } from "shared/ui/input/Input"
import { MarkdownInput } from "shared/ui/input/markdown/MarkdownInput"
import {
  HeadingLevel,
  MarkdownEditorProps
} from "shared/ui/input/markdown/components/MarkdownEditor"

import { useFloorFormContext } from "../../contexts/FloorFormContext"

export interface FloorRemarkInputProps extends Partial<InputRootProps> {}

const allowedHeadingLevels: HeadingLevel[] = [1]

const textareaProps: MarkdownEditorProps["textareaProps"] = {
  "data-testid": "floor__remark__input"
} as MarkdownEditorProps["textareaProps"]

export const FloorRemarkInput = React.memo((props: FloorRemarkInputProps) => {
  const { t } = useTranslation()
  const { field } = useController({ name: "floor.remark" })
  const { isReadonly, isDisabled } = useFloorFormContext()

  if (!field.value && !props.loading && isReadonly) return null

  return (
    <MarkdownInput.Root
      name="floor.remark"
      label={t("General.Remark")}
      maxLength={MAX_LENGTH_DESCRIPTION_TEXT}
      className="floor-form__remark"
      data-testid="floor__remark"
      {...props}
      readonly={isReadonly}
      disabled={isDisabled}
    >
      <MarkdownInput.Container maxHeight={null}>
        <MarkdownInput.Input
          allowedHeadingLevels={allowedHeadingLevels}
          textareaProps={textareaProps}
        />
        <MarkdownInput.Readonly />
        <MarkdownInput.Counter />
      </MarkdownInput.Container>
      <MarkdownInput.ErrorMessage />
    </MarkdownInput.Root>
  )
})
